import { __awaiter, __generator, __read, __spread } from "tslib";
import { SDKEnvironment } from '../core/sdk-environment';
var lf;
/**
 * Proxies `localforage` methods with strong-typing.
 */
function proxyLocalForageMethod(method) {
    var _this = this;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!lf) return [3 /*break*/, 2];
                        return [4 /*yield*/, SDKEnvironment.configureStorage()];
                    case 1:
                        lf = _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, lf.ready()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, lf[method].apply(lf, __spread(args))];
                }
            });
        });
    };
}
export var getItem = proxyLocalForageMethod('getItem');
export var setItem = proxyLocalForageMethod('setItem');
export var removeItem = proxyLocalForageMethod('removeItem');
export var clear = proxyLocalForageMethod('clear');
export var length = proxyLocalForageMethod('length');
export var key = proxyLocalForageMethod('key');
export var keys = proxyLocalForageMethod('keys');
export var iterate = proxyLocalForageMethod('iterate');
//# sourceMappingURL=storage.js.map